export default "__VITE_ASSET__9aAn4MAg__"